import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("FiscalMenuFilter")
export class FiscalMenuFilter {

  idMunicipio: number;
}
